import {useState, useEffect} from 'react'
import {adjustHeaderProp} from './utils'
import {HTTP_CALL_TYPE, API_URL_RESOURCE} from '../utils/constants'
const publicIp = require('react-public-ip')

let realIp
const GetRealIP = async () => {
    realIp = await publicIp.v4()
}
GetRealIP()
/**
//  * * This is custom hook which is used to maintain loading state, api respone
//  * @param URL - End point
//  * @param headers - Custom Headers if any
//  * @param params - input params if needed
//  * @param methodType - HTTP method type
//  */
export const useCentralApiHook = (
    endPoint,
    params = {},
    headerProp = {},
    method = 'GET'
) => {
    const [data, setData] = useState({})
    const [loading, setloading] = useState(true)
    const [hasError, setHasError] = useState(false)
    useEffect(() => {
        setloading(true)
        const callApi = async () => {
            const response = await apiRequest(endPoint, params, headerProp, method)
            if (Object.keys(response.error).length > 0) setHasError(true)
            setData(response.success)
            setloading(false)
        }
        callApi()
    }, [])
    return {data, loading, hasError}
}

export const apiFileUpload = async (
    endPoint,
    files,
    headerProp = {},
    method = 'POST'
) => {
    const adjHeaderProp = adjustHeaderProp(headerProp)
    if (realIp === undefined) {
        realIp = await publicIp.v4()
    }
    const options = {
        method,
        headers: {
            // 'real-ip': realIp,
            ...adjHeaderProp,
        },
        body: files,
        credentials: 'include',
    }
    // const requiredCredentials =
    //     process.env.REACT_APP_API_LOCAL_ENV === 'true' ? true : false
    // if (requiredCredentials) options['credentials'] = 'include'
    try {
        const response = await fetch(endPoint, options)
        if (response.status === 401) {
            //    setCookies('jwt-token', '', 1)
            // window.location.url = '/signup/login'
            sessionStorage.clear()
            window.location.reload(false)
        }
        if (response.status !== 200)
            return generateErrorResponse(
                'The server responded with an unexpected status.'
            )
        const result = await response.json()
        return result
    } catch (ex) {
        return generateErrorResponse('The server responded with an exception.')
    }
}

export const apiRequest = async (
    endPoint,
    params,
    headerProp = {},
    method = 'GET',
    addClientEntityIdheader = true
) => {
    const adjHeaderProp = addClientEntityIdheader
        ? adjustHeaderProp(headerProp)
        : headerProp
    if (realIp === undefined) {
        realIp = await publicIp.v4()
    }
    const options = {
        method,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            unit: sessionStorage.getItem('unit') || '',
            // 'real-ip': realIp,
            ...adjHeaderProp,
        },
        credentials: 'include',
    }
    // const requiredCredentials =
    //     process.env.REACT_APP_API_LOCAL_ENV === 'true' ? true : false
    // if (requiredCredentials) options['credentials'] = 'include'
    if (params) {
        if (method === 'GET') {
            if (params && Object.keys(params) && Object.keys(params)[0] === 'systemtype')
                endPoint += Object.keys(params).length > 0 ? '/' + params.systemtype : ''
            else
                endPoint +=
                    Object.keys(params).length > 0
                        ? '?' + objectToQueryString(params)
                        : ''
        } else options.body = JSON.stringify(params)
    }
    try {
        const response = await fetch(endPoint, options)
        if (response.status === 401) {
            // setCookies('jwt-token', '', 1)
            // window.location.url = '/signup/login'
            sessionStorage.clear()
            window.location.reload(false)
        }
        if (response.status === 400) {
            return generateErrorResponse('Access denied')
        }
        if (response.status !== 200)
            return generateErrorResponse(
                'The server responded with an unexpected status.'
            )
        const result = await response.json()
        return result
    } catch (ex) {
        return generateErrorResponse('The server responded with an exception.')
    }
}

export const objectToQueryString = obj =>
    Object.keys(obj)
        .map(key => key + '=' + obj[key])
        .join('&')

const generateErrorResponse = msg => ({
    statusCode: 0, // Error occured
    data: {result: []},
    error: {
        message: msg,
    },
})

// export const getConfiguration = url => {
//     // console.log('URL::', url)
//     let configuration = configurationJSON.configuration.find(p => p.url === url)
//     if (configuration === undefined)
//         configuration = {
//             url: '/login',
//             logo:
//                 'https://storage.googleapis.com/cdn-test-gcs-bucket/SignUp/figmd_logo.svg',
//         }
//     return Promise.resolve(configuration)
// }

// export const setCookies = (name, value, timespan) => {
//     const cookies = new Cookies()
//     cookies.set(name, value, {
//         path: '/',
//         secure: 0,
//         maxAge: timespan,
//         sameSite: 0,
//         domain: 0,
//         httpOnly: 0,
//     })
// }
